import { gql } from 'apollo-angular';

export const MarkActivityDoneDocument = gql(/* GraphQL*/ `
  mutation markActivityDone($input: MarkActivityDoneInputGraphql!)
  {
    markActivityDone (input: $input)
  }
`);
